module.exports = __webpack_public_path__ + "static/media/strong11.ec5ca7ed.jpg";